angular.module('kareo.ui.shared.directives.content-height', [])
.directive 'contentHeight', ['$window', ($window) ->
  restrict: 'A'

  scope:
    offset: '@',
    relativeTo: '@'

  link: (scope, element, attr) ->
    offset = scope.offset || 0

    getMainContent = ->
      return document.querySelector(scope.relativeTo) ||  document.querySelector('.main-content')

    #get offsetHeight but floor pixel rounding
    getElementHeight = (element) ->
      Math.floor element.getBoundingClientRect().height

    setInterval ->
      elementHeight = getElementHeight element[0]

      node = getMainContent()

      if node and elementHeight
        height = getElementHeight(node) - offset
        return if height == elementHeight
        #allow shrinking
        if elementHeight > height
          element.css('height', '')
          elementHeight = getElementHeight element[0]
          height = elementHeight if elementHeight > height

        element.css { height: height + 'px' }

      return

    , 500

    return
]
